import CalendarSvg from './assets/Calendar.svg';
import DropdownSvg from './assets/Dropdown.svg';
import NumberSvg from './assets/Number.svg';
import TextSvg from './assets/Text.svg';

export const CUSTOM_FIELD_MODES = {
    CREATE: 'create',
    EDIT: 'edit'
}

export const CUSTOM_FIELD_TYPES = {
    DROPDOWN: 'DROPDOWN',
    TEXT: 'TEXT',
    NUMBER: 'NUMBER',
    DATE: 'DATE',
}

export const QUERY_KEYS = {
    customFieldList: 'customFieldList',
    customFieldEdit: 'customFieldEdit',
    customFieldReorder: 'customFieldReorder',
};

export const CUSTOM_FIELDS_ROUTES = {
    LIST_VIEW: 'custom-fields',
    SELECT_CUSTOM_FIELD_TYPE: 'create',
    CREATE_CUSTOM_FIELD: 'create/:type',
    EDIT_CUSTOM_FIELD: 'edit/:type/:id',
}

export const CUSTOM_FIELD_API_ACTIONS = {
    CREATE: 'CREATE',
    EDIT: "EDIT",
    TOGGLE: "TOGGLE"
};

export const CUSTOM_FIELD_LIST_PAGE_ROUTE = '/app/sharedmailbox/edit/${smId}/custom-fields';

export const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again';

export const CustomFieldsConstants = () => {

    const currentPath = window.location.pathname; 

    return {
        title: 'Custom fields',
        crownText: 'On a higher plan',
        heading: 'Custom fields for your shared inboxes',
        description: 'Create custom fields to add more information to your conversations and manage them more effectively.',
        image: 'https://hivercdn.s3.us-west-2.amazonaws.com/images/CustomFieldImage.svg',
        learnMoreLink: 'https://help.hiverhq.com/organizeyouremails/custom-fields',
        createFieldBtnText:'Add custom field',
        createFieldBtnTextRoute: `${currentPath}/${CUSTOM_FIELD_MODES.CREATE}`,
        editFieldBtnTextRoute: `${currentPath}/${CUSTOM_FIELD_MODES.EDIT}`,
        upgradeRoute: '/app/settings/account/upgrade',
        upgradeBtnText: 'Upgrade'
    }

}

export const DROPDOWN_CUSTOM_FIELD = {
    type: CUSTOM_FIELD_TYPES.DROPDOWN,
    icon: DropdownSvg,
    title: 'Drop-down',
    description: 'Choose one option in the menu of choices'
};

export const DATE_CUSTOM_FIELD = {
    type: CUSTOM_FIELD_TYPES.DATE,
    icon: CalendarSvg,
    title: 'Date',
    description: 'Select a date from the calendar'
};

export const NUMBER_CUSTOM_FIELD = {
    type: CUSTOM_FIELD_TYPES.NUMBER,
    icon: NumberSvg,
    title: 'Number',
    description: 'Enter a number with no decimals'
};

export const TEXT_CUSTOM_FIELD = {
    type: CUSTOM_FIELD_TYPES.TEXT,
    icon: TextSvg,
    title: 'Text',
    description: 'Use text to add additional information'
};

export const SELECT_CUSTOM_FIELD_PAGE_CONSTANTS = {
    HEADING: 'Add field',
    SUBHEADING: 'Select field type',
    CARDS: [DROPDOWN_CUSTOM_FIELD, DATE_CUSTOM_FIELD, NUMBER_CUSTOM_FIELD, TEXT_CUSTOM_FIELD]
};

export const CUSTOM_FIELD_TYPES_DETAILS = {
    [CUSTOM_FIELD_TYPES.DROPDOWN]: {
        FIELD_NAME: 'Dropdown',
        FIELD_DESCRIPTION: 'This field enables the user to select one option from a preset list.'
    },
    [CUSTOM_FIELD_TYPES.TEXT]: {
        FIELD_NAME: 'Text',
        FIELD_DESCRIPTION: 'This field enables the users to add a few words'
    },
    [CUSTOM_FIELD_TYPES.NUMBER]: {
        FIELD_NAME: 'Number',
        FIELD_DESCRIPTION: 'This field enables people to enter a number with no decimal.'
    },
    [CUSTOM_FIELD_TYPES.DATE]: {
        FIELD_NAME: 'Date',
        FIELD_DESCRIPTION: 'This field enables the user to select a past or future date from a calendar.'
    }
}
export const PREVIEW_PAGE_HEADING  = 'Preview';
export const PREVIEW_PAGE_DESCRIPTION = 'This is what agents will see when they interact with this field in Agent Workspace.';

export const CUSTOM_FIELD_GAINSIGHT = {
    LEFT_PANEL_CLICKED: 'clicked_on_custom_field',
    CREATED: 'created_ custom_field',
    EDITED: 'edited_custom_field',
    ARCHIVED: 'clicked_on_archive_dropdown_option',
    DISABLED: 'clicked_on_disable_custom_field',
    CF_MANDATORY_CLICKED: 'CF_Mandatory_Clicked'
};

export const CUSTOM_FIELD_CREATE_EDIT_SECTION_BODY_ID = "custom-field-create-edit-section-body";

export const CF_TEST_CONVERSATIONS_CLICKED_LOCALSTORAGE_KEY = "CF_TEST_CONVERSATIONS_CLICKED_LOCALSTORAGE_KEY";

export const CUSTOM_FIELD_AI_PROMPT_INPUT_ID = "custom-field-ai-prompt-input";